export default "__VITE_ASSET__BgaJ1LVC__"